<template>
  <div v-loading="loading">
    <div class="as-order-wrap" v-if="totalElements">
      <div v-for="item in asMsgList" :key="item.id">
        <asOrderItem :item="item" @closeDialog="closeDialog" />
      </div>
    </div>
    <div v-else style="text-align: center;color: rgba(0,0,0,0.65);">
      暂无数据
    </div>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-size="size"
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :pager-count="11"
      layout="total, sizes, prev, pager, next"
      :total="totalElements"
      v-if="totalElements"
    >
    </el-pagination>
  </div>
</template>
<script>
import { queryPendingMsg } from "@/models/aftersaleModel";
import asOrderItem from "./asOrderItem.vue";
import { getHMS } from "@/utils/time.js";
let timer = null;
export default {
  name: "asOrder",
  components: { asOrderItem },
  data() {
    return {
      asMsgList: [],
      minheight: "300px",
      loading: false,
      page: 1,
      size: 10,
      totalElements: 0
    };
  },
  methods: {
    setList(res) {
      this.asMsgList = res.list || [];
      this.page = res.page;
      this.size = res.size;
      this.totalElements = res.total;
      this.initData(this.asMsgList);
      // 有数据才倒计时展示时间
      // if (this.asMsgList.length > 0) {
      if (res.list.length > 0) {
        timer = setInterval(() => {
          this.initData(res.list);
        }, 1000);
      }
    },
    beforeDestroy() {
      this.clearTimer();
    },
    //获取待处理售后单
    async getList(page, size) {
      // console.log("get--as", page, size);
      clearInterval(timer);
      timer = null;
      const shop_id = Number(localStorage.getItem("shop_id"));
      this.loading = true;
      try {
        const params = {
          shop_id,
          page: page || this.page || 1,
          page_size: size || this.size || 10,
          type: 2 //2-售后，3-拒收
        };
        const res = await queryPendingMsg(params);
        this.loading = false;
        this.asMsgList = res.list || [];
        this.totalElements = res.total;
        this.initData(this.asMsgList);
        // 有数据才倒计时展示时间
        // if (this.asMsgList.length > 0) {
        if (res.list && res.list.length > 0) {
          timer = setInterval(() => {
            this.initData(res.list);
          }, 1000);
        }
      } catch (error) {
        this.asMsgList = [];
        this.totalElements = 0;
        this.loading = false;
        this.$message.error(error.message);
      }
    },

    initData(content) {
      const data = (content || []).map(item => {
        const time = getHMS(item.time);
        // console.log("time--", time);
        return { ...item, ...time };
      });
      this.$nextTick(() => {
        this.asMsgList = data;
      });
    },
    // 每页条数
    handleSizeChange(val) {
      this.loading = true;
      this.size = val;
      this.page = 1;
      this.getList(1, val);
    },
    // 页码改变
    handleCurrentChange(val) {
      this.loading = true;
      this.page = val;
      this.getList(val, this.size);
    },
    // 清除定时器
    clearTimer() {
      clearInterval(timer);
      timer = null;
    },
    closeDialog() {
      this.$emit("setOrderFlag");
    }
  }
};
</script>
<style lang="scss" scoped>
.as-order-wrap {
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  max-height: 460px;
  overflow-y: scroll;
  border-bottom: 1px solid #e9e9e9;
  padding: 0 16px;
  .msg-item {
    border: 1px solid #e9e9e9;
    padding: 16px;
    margin-bottom: 12px;
    .bold {
      color: rgba(0, 0, 0, 0.85);
      font-weight: bold;
    }
    .m-t-8 {
      margin-top: 8px;
    }
    .m-l-r-8 {
      margin: 0 8px;
    }
    .m-l-20 {
      margin-left: 20px;
    }
    .sku-width {
      width: 130px;
      display: inline-block;
    }
    .time-item {
      background-color: #f71000;
      color: #fff;
      width: 22px;
      display: inline-block;
      text-align: center;
    }
    .time-item-point {
      color: #f71000;
      font-weight: bold;
    }
    .time-out-txt {
      color: #f71000;
    }
    .handle-btn {
      color: #ff6224;
      border: 1px solid #ff6224;
      cursor: pointer;
      padding: 4px 11px;
      font-size: 13px;
      border-radius: 2px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pendingOrder/asOrder.vue